module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("\n    " + _vm._s(_vm.setName) + " Set\n    "), _c('span', [_vm._v("\n      " + _vm._s(_vm.set.jpCaption) + "・セット\n    ")])]), _vm._v(" "), _c('p', {
    staticClass: "notices"
  }, [_vm._v("\n    " + _vm._s(_vm.set.notices) + "\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.getNumberOfFigures(_vm.set.figures),
    attrs: {
      "id": "figures"
    }
  }, _vm._l((_vm.set.figures), function(figure, index) {
    return _c('table', {
      key: index
    }, [_c('thead', [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('h3', [_vm._v("\n                Figure " + _vm._s(figure.order) + ": " + _vm._s(figure.rythmn) + "\n              ")]), _vm._v("\n                " + _vm._s(figure.summary) + "\n              "), _c('p', [_vm._v("\n                " + _vm._s(_vm.getBars(figure)) + " bars + 8 bar lead in\n              ")])])])]), _vm._v(" "), _c('tbody', _vm._l((figure.movements), function(movement) {
      return _c('tr', {
        staticClass: "movement"
      }, [_c('td', {
        staticClass: "bar",
        class: movement.type
      }, [_vm._v("\n              " + _vm._s(movement.bar) + "\n            ")]), _vm._v(" "), (!movement.caption) ? _c('td', {
        key: "movementWithCaption",
        staticClass: "summary",
        class: movement.type
      }, [_vm._v("\n              " + _vm._s(movement.summary) + "\n            ")]) : _c('td', {
        staticClass: "summary withCaption",
        class: movement.type,
        on: {
          "click": function($event) {
            _vm.openMovementCaption('captiondialog', _vm.figureIndex, movement.summary, movement.caption, movement.image)
          }
        }
      }, [_c('md-button', {}, [_vm._v(_vm._s(movement.summary)), _c('i', {
        staticClass: "material-icons"
      }, [_vm._v("launch")])])], 1)])
    }))])
  })), _vm._v(" "), _c('md-dialog', {
    ref: "captiondialog",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    },
    on: {
      "open": _vm.onOpen,
      "close": _vm.onClose
    }
  }, [_c('md-dialog-title', [(_vm.alert.image) ? _c('img', {
    key: "animation",
    staticClass: "animation",
    attrs: {
      "src": '/static/img/movement/' + _vm.alert.image
    }
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.alert.title) + "\n      ")]), _vm._v(" "), _c('md-dialog-content', [_c('ul', [(!Array.isArray(_vm.alert.contentHtml)) ? _c('li', {
    key: "one_sentence"
  }, [_vm._v(_vm._s(_vm.alert.contentHtml))]) : _vm._l((_vm.alert.contentHtml), function(instruction, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(instruction))])
  })], 2)]), _vm._v(" "), _c('md-dialog-actions', [_c('router-link', {
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'ReportMovement',
        params: {
          setName: _vm.setName,
          figureNumber: _vm.alert.figureNumber,
          movement: _vm.alert.title
        }
      }
    }
  }, [_vm._v("\n          誤字脱字を報告する\n        ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.closeDialog('captiondialog')
      }
    }
  }, [_vm._v(_vm._s(_vm.alert.close))])], 1)], 1), _vm._v(" "), _c('footer', [_c('router-link', {
    staticClass: "md-raised md-primary",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'Set',
        params: {
          setName: _vm.setName
        }
      },
      "id": "btn-return"
    }
  }, [_vm._v("\n      戻る / Back\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d84b6b58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Figures.vue
// module id = 343
// module chunks = 1